import { createEntityAdapter } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ProjectIdLayoutIdPair } from 'types/entity';

export const layoutCopyUpdateAdapter = createEntityAdapter<ProjectIdLayoutIdPair>({
  selectId: (model) => `${model.project_id}/${model.layout_id}`,
});

export const {
  selectById,
  selectAll,
  selectTotal,
} = layoutCopyUpdateAdapter.getSelectors<RootState>((state) => state.layoutCopyUpdate);
